
























import { mapState } from 'vuex';
import draggable from 'vuedraggable';
import { PosWaypoint } from 'gl-ms-positions';
import {
    ACTION_NEW_ROUTE,
    ACTION_SET_WAYPOINT,
    ACTION_DELETE_WAYPOINT,
    ACTION_UPDATE_WAYPOINT,
    ACTION_SET_WAYPOINTS,
    ACTION_SET_WAYPOINT_BY_INDEX,
} from '@/store/modules/planning';

import waypointPicker from '@/components/common/waypointPicker.vue';
import { waypointType, waypoint } from '@/services/positions';

export default {
    data(this: any) {
        return {
            adding: false,
            panels: this.$t('fleetPlanning.planFromEmpty'),
        };
    },

    props: {
        fromDispo: {
            type: Boolean,
            default: false,
        },
        waypoints: {
            type: Array,
            default: () => [],
        },
    },

    components: {
        waypointPicker,
        draggable,
    },

    computed: {
        internalWaypoints: {
            get(this: any) {
                return this.waypoints;
            },
            async set(this: any, waypoints: PosWaypoint[]) {
                this.$emit('updateWaypoints', waypoints);
            },
        },
    },

    methods: {
        addWaypoint(this: any, item: PosWaypoint) {
            this.adding = false;
            this.$emit('addWaypoint', item);
        },

        updateWaypoint(this: any, item: PosWaypoint) {
            this.$emit('updateWaypoint', item);
        },

        showPlaceholderInput(this: any) {
            this.adding = true;
        },

        hideAdding(this: any) {
            this.adding = false;
        },

        deleteWaypoint(this: any, item: PosWaypoint) {
            this.$emit('deleteWaypoint', item);
        },
        dragMove(this: any, dragEvent: any) {
            if (this.fromDispo) {
                if (dragEvent.draggedContext.futureIndex === 0 || dragEvent.draggedContext.futureIndex === (this.waypoints - 1)) {
                    return false;
                }
            }
            return true;
        },
    },
};
